import SpotInnovationLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-innovation-light.svg';
import clsx from 'clsx';
import { AnimatePresence } from 'framer-motion';
import { ReactNode, useMemo, useState } from 'react';

import { AnimatedText, reactNodeParser } from '@components/AnimatedText';

interface ReactNodeBundleBotProps {
  children: ReactNode;
  onComplete?: () => void;
  className?: string;
}

/**
 * BundleBot variant optimized for ReactNode input with proper positioning
 * - Semantic content defines the layout (normal positioning)
 * - AnimatedText overlays absolutely on top during animation
 * - After animation, semantic content remains as the final state
 */
const ReactNodeBundleBot = ({
  children,
  onComplete,
  className,
}: ReactNodeBundleBotProps) => {
  const [showAnimated, setShowAnimated] = useState(true);
  const [showSemantic, setShowSemantic] = useState(false);

  const parsedText = useMemo(() => reactNodeParser(children), [children]);

  const handleAnimationComplete = () => {
    // Show semantic content first, then trigger fade out
    setShowSemantic(true);
    // Small delay to let semantic content start appearing before animated fades out
    setTimeout(() => setShowAnimated(false), 100);
    onComplete?.();
  };

  return (
    <div
      data-testid="bundle-bot"
      className={clsx('bundleBot_wrapper', className)}
    >
      <div className="bundleBot">
        <div className="bundleBot_img">
          <img src={SpotInnovationLight} alt="Bundle Bot" />
        </div>
        <div className="bundleBot_textContainer">
          <div
            className={clsx(
              !showSemantic && 'bundleBot_semanticContent--hidden'
            )}
          >
            {children}
          </div>

          <AnimatePresence mode="wait">
            {showAnimated && (
              <div className="bundleBot_animatedOverlay">
                <AnimatedText
                  key="animated"
                  text={parsedText}
                  once
                  onComplete={handleAnimationComplete}
                />
              </div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export { ReactNodeBundleBot };
